import { useEffect, useState } from 'react';

export function useTabLoadType() {
  const [loadType, setLoadType] = useState('fresh');

  useEffect(() => {
    const TAB_CLOSE_THRESHOLD = 2000; // 2 seconds
    let lastVisibleTime = Date.now();
    let hiddenStartTime = 0;
    let detectedType = 'fresh';

    // Check navigation type first
    const navigationEntries = performance.getEntriesByType('navigation');
    if (navigationEntries.length > 0) {
      const navEntry = navigationEntries[0];
      if (navEntry.type === 'reload') {
        detectedType = 'reload';
      }
    }

    // Handle visibility changes for restoration detection
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        hiddenStartTime = Date.now();
      } else {
        const hiddenDuration = Date.now() - hiddenStartTime;
        if (hiddenDuration > TAB_CLOSE_THRESHOLD && detectedType !== 'reload') {
          detectedType = sessionStorage.getItem('tabWasClosed') === 'true' 
            ? 'restore' 
            : 'hidden-restore';
        }
        lastVisibleTime = Date.now();
      }
    };

    // Set beforeunload listener
    const handleBeforeUnload = () => {
      sessionStorage.setItem('tabWasClosed', 'true');
      sessionStorage.setItem('lastUnloadTime', Date.now().toString());
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Initial detection
    if (detectedType === 'fresh' && sessionStorage.getItem('tabWasClosed') === 'true') {
      const lastUnload = parseInt(sessionStorage.getItem('lastUnloadTime') || '0');
      if (Date.now() - lastUnload > TAB_CLOSE_THRESHOLD) {
        detectedType = 'restore';
      }
    }

    setLoadType(detectedType);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return loadType;
}